import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { trackMixpanelPageView } from 'helpers/post';
import classNames from 'classnames';

export class MobileNavBar extends Component {
  trackLogin = () => {
    trackMixpanelPageView('IntroLogInClick');
  };
  render() {
    const { pathname, logo, logoWidth, authenticated } = this.props;
    const logoProps = {
      src: logo,
      style: { width: logoWidth },
    };
    const slug = pathname ? pathname.split('/').pop() : '';
    return (
      <div>
        <div className="mobileNavBarV2Placeholder"></div>
        <div className={classNames('mobileNavBarV2', { 'border-bottom': slug !== 'intro' })}>
          {this.props.authenticated && (
            <i className="material-icons" onClick={this.props.toggleCollapsed}>
              reorder
            </i>
          )}
          {!authenticated ? (
            <a href="https://www.go4.io/" target=" _blank" rel="noopener noreferrer">
              <img {...logoProps} className="logo" alt="Go4" />
            </a>
          ) : (
            <Link to={this.props.logoUrl ? this.props.logoUrl : '/'}>
              <img {...logoProps} className="logo" alt="Go4" />
            </Link>
          )}
          {['create-account', 'intro', 'role', 'organization-type', 'sign-up'].includes(slug) && (
            <Link to="/" className="login-btn gotham-medium-font" onClick={this.trackLogin}>
              <div>Log In</div>
            </Link>
          )}
        </div>
      </div>
    );
  }
}

export default MobileNavBar;
